<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="utf-8">
    <meta content="width=device-width, initial-scale=1.0" name="viewport">

    <title>Remote Monitoring System</title>
    <meta content="" name="description">
    <meta content="" name="keywords">

    <!-- Favicons -->
    <!-- <link href="assets/img/favicon.png" rel="icon">-->
    <link href="assets/img/apple-touch-icon.png" rel="apple-touch-icon">

    <!-- Google Fonts -->



</head>

<body>
    <app-header></app-header>


    <section id="hero" class="hero_slide">
        <div data-bs-interval="5000" class="" data-bs-ride="carousel">
            <div class="container">


                <div class="row">
                    <div class="col-lg-6 col-md-6 mt-3 cust-slider-left-text pad_top_30">
                        <h2 class="animate__animated animate__fadeInDown text-alignment-center pt-1 pb-4">Blog</h2>
                        <p class="animate__animated animate__fadeInUp width-100 m-0 text_jus1">A blog, short for weblog, is a frequently updated web page used for personal commentary or business content. Blogs are often interactive and include sections at the bottom of individual blog posts where readers can leave comments.</p>
                        <div class="flex_center pad-top-25">
                            <a href="https://www.samyak.com/contact-us/"
                                class="btn-get-started animate__animated animate__fadeInUp scrollto margin-top-25 cursor_pointer">Get
                                Started</a>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 text-right">
                        <img src="assets/images/cuate.svg" class="slider-img-level slider-img">
                    </div>
                </div>


            </div>

        </div>


    </section>



    <main id="main">

        <section id="clients" class="clients">
            <div class="container p-0">


                <div class="row client-logo-main">

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Adani-power-logo.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Cognitive Technologies.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Anodyne Technologies.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Energy Doctor (Tricolite Energy Soln).svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Navi mumbai corporation.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/rech.svg" class="img-fluid" alt="">
                    </div>

                </div>

            </div>
        </section>

        <section id="article" class="services space-comman-articalsetino pb-3 pt-5 section-bg">
            <div class="container">
                <div class="section-title article-article">

                    <p>Check out Our Latest Article</p>
                </div>


            </div>
        </section>


        <section id="article" class="services space-comman-articalsetino pb-5 section-bg">
            <div class="container aos-init aos-animate" data-aos="fade-up">



                <div class="pad_15">

                <!-- <div class="row">
                    <owl-carousel [options]="SlideOptions2" [carouselClasses]="['owl-theme', 'sliding']">
                        <div class="item" *ngFor="let img of Images2">

                            <div class=" articale-container d-flex align-items-stretch mt-4 aos-init aos-animate"
                                data-aos="zoom-in" data-aos-delay="100">
                                <div class="image-box_new">
                                    <div class="icon-container icon-container2"><img src="{{img.img}}"
                                            style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                                    <div class="text-container">
                                        <h4><a href="" class="image-box-ancher">{{img.title}}</a></h4>
                                        <p class="text_jus">{{img.text}}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </owl-carousel>
                </div> -->

             
                  
                <div class="row d-flex">
              
                    <div class="col-lg-3 col-md-4 col-12 padding-right-0">
                    <div class="align-items-stretch mt-4 aos-init "
                      >
                        <div class="image-box_new">
                            <div class="icon-container icon-container2"><img src="assets/images/latest_article_img1.png"
                                    style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                            <div class="text-container">
                                <h4><a href="" class="image-box-ancher">The Office of Strategy Management</a></h4>
                                <p class="text_jus">Why is there such a persistent gap between ambition and performance? The gap...</p>
        
                            </div>
                        </div>
                    </div>
                    </div>

                    <div class="col-lg-3 col-md-4 col-12 padding-right-0">
                    <div class="align-items-stretch mt-4 aos-init"
                      >
                        <div class="image-box_new">
                            <div class="icon-container icon-container2"><img src="assets/images/latest_article_img2.png"
                                    style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                            <div class="text-container">
                                <h4><a href="" class="image-box-ancher">Development Articles Programmer</a></h4>
                                <p class="text_jus">Hello guys, someone asks me another day, would you mind putting...</p>
        
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-4 col-12 padding-right-0">
                    <div class="align-items-stretch mt-4 aos-init"
                       >
                        <div class="image-box_new">
                            <div class="icon-container icon-container2"><img src="assets/images/latest_article_img3.png"
                                    style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                            <div class="text-container">
                                <h4><a href="" class="image-box-ancher">How to Be Creative - A Year of Living Better Guides</a></h4>
                                <p class="text_jus">You know how you’ve got this image of the creator as a somewhat crazy, slightly...</p>
        
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-3 col-md-4 col-12 padding-right-0">
                    <div class="align-items-stretch mt-4 aos-init"
                       >
                        <div class="image-box_new">
                            <div class="icon-container icon-container2"><img src="assets/images/latest_article_img4.png"
                                    style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                            <div class="text-container">
                                <h4><a href="" class="image-box-ancher">In publishing and graphic Lorem ipsum.</a></h4>
                                <p class="text_jus">Why is there such a persistent gap between ambition and performance? The gap...</p>
        
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

            <div class="row d-flex">
              
                <div class="col-lg-3 col-md-4 col-12 padding-right-0">
                <div class="align-items-stretch mt-4 aos-init "
                  >
                    <div class="image-box_new">
                        <div class="icon-container icon-container2"><img src="assets/images/latest_article_img5.png"
                                style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                        <div class="text-container">
                            <h4><a href="" class="image-box-ancher">In publishing and graphic Lorem ipsum.</a></h4>
                            <p class="text_jus">Hello guys, someone asks me another day, would you mind putting...</p>
    
                        </div>
                    </div>
                </div>
                </div>

                <div class="col-lg-3 col-md-4 col-12 padding-right-0">
                <div class="align-items-stretch mt-4 aos-init"
                  >
                    <div class="image-box_new">
                        <div class="icon-container icon-container2"><img src="assets/images/latest_article_img6.png"
                                style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                        <div class="text-container">
                            <h4><a href="" class="image-box-ancher">In publishing and graphic Lorem ipsum.</a></h4>
                            <p class="text_jus">You know how you’ve got this image of the creator as a somewhat crazy, slightly...</p>
    
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 col-12 padding-right-0">
                <div class="align-items-stretch mt-4 aos-init"
                   >
                    <div class="image-box_new">
                        <div class="icon-container icon-container2"><img src="assets/images/latest_article_img7.png"
                                style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                        <div class="text-container">
                            <h4><a href="" class="image-box-ancher">In publishing and graphic Lorem ipsum.</a></h4>
                            <p class="text_jus">Why is there such a persistent gap between ambition and performance? The gap...</p>
    
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-3 col-md-4 col-12 padding-right-0">
                <div class="align-items-stretch mt-4 aos-init"
                   >
                    <div class="image-box_new">
                        <div class="icon-container icon-container2"><img src="assets/images/latest_article_img8.png"
                                style="border-top-left-radius: 20px; border-top-right-radius:20px;"></div>
                        <div class="text-container">
                            <h4><a href="" class="image-box-ancher">In publishing and graphic Lorem ipsum.</a></h4>
                            <p class="text_jus">Hello guys, someone asks me another day, would you mind putting...</p>
    
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
            
                
               

                </div>


            </div>
        </section>



        <app-footer></app-footer>


    </main>




</body>

</html>